export const DEFAULT_COLOR = '#6E6E6E';
export const DEFAULT_SELECT_VALUE = 'Выбрать из списка';

export const FILE_MAX_SIZE = 20971520;

export const TITLE_RU = 'titleRu';
export const TITLE_EN = 'titleEn';
export const COLOR = 'color';
export const LOGO_URL = 'logoUrl';
export const LINK = 'link';
export const FILE = 'file';
export const EXTENSION = 'extension';
export const SIZE = 'size';

export const NAME_RU = 'nameRu';
export const LASTNAME_RU = 'lastnameRu';

export const CHANGE_STREAM_NAME = 'streamId';
export const DEFAULT_CHANGE_STREAM = {
    ru: 'Переместить в...',
    en: 'Move to...'
};
export const CHANGE_STREAM = {
    ru: 'Вы уверены, что хотите перенести эпизод в другой зал?',
    en: 'Are you sure you want to move this episode to another stream?'
};
